export default "__VITE_ASSET__B8r5o0$e__"